var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_26774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 20H10.0145C8.06369 19.9991 6.15572 19.4275 4.52563 18.3558C2.89554 17.2841 1.61453 15.759 0.840372 13.9683C0.0662181 12.1776 -0.167264 10.1996 0.168683 8.27794C0.504631 6.35624 1.39534 4.57477 2.73109 3.15295C4.06684 1.73114 5.7893 0.731076 7.68631 0.275949C9.58332 -0.179179 11.572 -0.0694963 13.4075 0.591488C15.2429 1.25247 16.845 2.43589 18.0163 3.99597C19.1876 5.55606 19.877 7.42468 19.9995 9.37167V9.42417V20ZM10.0145 1.66667C7.80439 1.66667 5.68478 2.54464 4.12198 4.10744C2.55917 5.67025 1.6812 7.78986 1.6812 10C1.6812 12.2101 2.55917 14.3298 4.12198 15.8926C5.68478 17.4554 7.80439 18.3333 10.0145 18.3333H18.3329V9.45083C18.19 7.3411 17.2518 5.36419 15.7078 3.91936C14.1638 2.47453 12.1291 1.66943 10.0145 1.66667V1.66667Z",
    fill: "#8C92A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 5.83301H5.83325V7.49967H10.8333V5.83301Z",
    fill: "#8C92A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 9.16699H5.83325V10.8337H14.1666V9.16699Z",
    fill: "#8C92A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 12.5H5.83325V14.1667H14.1666V12.5Z",
    fill: "#8C92A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_26774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8bf74eea7b1267ef3a10cd0f1a84fb9a.svg";
export { ForwardRef as ReactComponent };